import React from "react";
import {
  AnalyticsSection,
  StatCard,
  PieChart,
  BarChart,
  AreaChart,
} from "./ChartComponents";
import { months, memberData } from "./analyticsData";

const MembersAnalytics = () => {
  return (
    <div>
      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <StatCard
          title="Total Members (including suspended)"
          value={memberData.totalMembers}
        />
        <StatCard
          title="Active Members (excluding suspended)"
          value={memberData.activeMembers}
        />
        <StatCard
          title="New Members (This Month)"
          value={memberData.newMembersThisMonth}
        />
        <StatCard
          title="Member Retention Rate"
          value={memberData.memberRetentionRate}
        />
      </div>

      {/* Member Breakdown */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <AnalyticsSection title="Total Member breakdown by size">
          <PieChart
            segments={memberData.memberBreakdown}
            height={450}
            segmentValueLabel="members"
          />
        </AnalyticsSection>

        <AnalyticsSection title="New members by month">
          <div className="h-80">
            <BarChart
              data={memberData.newMembersMonthly}
              categories={months}
              height={280}
            />
          </div>

          <div className="mt-4 grid grid-cols-3 gap-4">
            <div className="text-center">
              <p className="text-xs text-gray-500">Total New Members (Year)</p>
              <p className="text-xl font-bold text-cpaGold">
                {memberData.newMembersMonthly[0].data.reduce(
                  (a, b) => a + b,
                  0
                )}
              </p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">Average Monthly</p>
              <p className="text-xl font-bold text-cpaGold">
                {(
                  memberData.newMembersMonthly[0].data.reduce(
                    (a, b) => a + b,
                    0
                  ) / 12
                ).toFixed(1)}
              </p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">Renewal Rate</p>
              <p className="text-xl font-bold text-cpaGold">
                {memberData.memberRetentionRate}
              </p>
            </div>
          </div>
        </AnalyticsSection>
      </div>

      {/* Member Engagement */}
      <AnalyticsSection title="Average member engagement over time">
        <div className="mb-4">
          <p className="text-sm text-gray-500 mb-2">
            Percentage of members actively engaging with chamber events, emails,
            and Chamber Perks App™
          </p>

          <div className="mt-4">
            <AreaChart
              series={[memberData.memberEngagement]}
              labels={months}
              height={250}
            />
          </div>

          <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-500 mb-1">Average Engagement</p>
              <p className="text-xl font-bold text-cpaGold">
                {Math.round(
                  memberData.memberEngagement.data.reduce((a, b) => a + b, 0) /
                    12
                )}
                %
              </p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-500 mb-1">Highest Month</p>
              <p className="text-xl font-bold text-cpaGold">
                {Math.max(...memberData.memberEngagement.data)}% (Dec)
              </p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-500 mb-1">Lowest Month</p>
              <p className="text-xl font-bold text-cpaGold">
                {Math.min(...memberData.memberEngagement.data)}% (Jan)
              </p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-500 mb-1">Growth (YTD)</p>
              <p className="text-xl font-bold text-cpaGold">
                {memberData.memberEngagement.data[11] -
                  memberData.memberEngagement.data[0]}
                %
              </p>
            </div>
          </div>
        </div>
      </AnalyticsSection>

      {/* Member Longevity */}
      <AnalyticsSection title="Member longevity breakdown">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {[
            { label: "<1 Year", value: 23, percentage: "12%" },
            { label: "1-2 Years", value: 45, percentage: "24%" },
            { label: "3-5 Years", value: 52, percentage: "28%" },
            { label: "6-10 Years", value: 41, percentage: "22%" },
            { label: ">10 Years", value: 26, percentage: "14%" },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-lg shadow-sm border border-gray-100"
            >
              <p className="text-sm text-gray-500">{item.label}</p>
              <p className="text-2xl font-bold mt-1">{item.value}</p>
              <p className="text-xs text-gray-500 mt-1">
                {item.percentage} of members
              </p>
              <div className="w-full bg-gray-200 h-1 mt-2 rounded-full">
                <div
                  className="bg-cpaGold h-1 rounded-full"
                  style={{ width: item.percentage }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </AnalyticsSection>
    </div>
  );
};

export default MembersAnalytics;
